<template>
  <el-dialog
    v-drag:common
    custom-class="city-owner transtant-input"
    :title="title"
    :visible.sync="modal"
    :modal="false"
    width="33%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    center
  >
    <div class="dialog-content-item">
      省市：
      <city-select v-model="cities" :filterable="false"></city-select>
    </div>
    <div class="dialog-content-item">
      业主：
      <data-select
        :loader="getOwnerList"
        multiple
        v-model="owners"
      ></data-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">搜索</el-button>
    </span>
  </el-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  props: ['title', 'visible'],
  data() {
    return {
      modal: false,
      props: {
        label: 'regionName',
        value: 'com',
        multiple: true
      },
      cities: [],
      owners: []
    };
  },
  watch: {
    modal(val) {
      this.$emit('update:visible', val);
    },
    visible(val) {
      this.modal = val;
    }
  },
  methods: {
    async getOwnerList() {
      const res = await this.$fetch('/windfarm/project/getOwnerList');
      const owners = res.data.ownerList || [];
      return owners.map(item => ({
        value: item.name,
        label: item.name
      }));
    },
    save() {
      const { cities, owners } = this;
      let adcodes = [];
      if (!isEmpty(cities)) {
        cities.forEach(city => {
          if (city && city[city.length - 1]) {
            const arr = city[city.length - 1].split(',');
            if (arr && arr[0]) {
              adcodes.push(arr[0]);
            }
          }
        });
      }
      //console.log('save', { adcodes, owners, cities });
      this.$emit('save', {
        adcodes: adcodes.join(','),
        owners: owners.join(',')
      });
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="less">
.city-owner {
  .dialog-content-item {
    display: flex;
    // color: #fff;
    line-height: 34px;
    padding: 20px;

    .city-select {
      flex: 1;
    }

    .data-select {
      flex: 1;
    }
  }
}
</style>
